// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1kcPx","footer":"ModalUpdate_footer__3YHxH"};